import type { JSX } from 'react';

import { css, cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { BaseStyle, ColorConstant, FlexDirection, Font, FontWeight, Spacing, TextAlign } from 'src/styles';

import { MFormItemError } from '../MFormItemError/MFormItemError';

export const titleColStyle = (type: 'error' | 'success') => css`
  color: ${type === 'error' ? ColorConstant.RED6 : ColorConstant.GREEN6};
  ${FontWeight.bold}
  ${TextAlign.center}
  ${Font.lg}
  ${Spacing.my12}
  ${BaseStyle.level}
  ${FlexDirection.column}
`;

export const messageSpanStyle = css`
  ${Font.md}
  ${TextAlign.center}
  color: ${ColorConstant.GRAY7};
`;

export const submissionResultRowStyle = css`
  width: 100%;
`;

interface SubmissionResultProps {
  type: 'success' | 'error';
  title?: string;
  message?: string | JSX.Element;
}

export const SubmissionResult = ({
  type,
  title = type === 'error' ? 'Submission Failed' : 'Submission Succeeded',
  message,
}: SubmissionResultProps) => {
  return (
    <Row className={submissionResultRowStyle}>
      <Col span={24} className={titleColStyle(type)}>
        {type === 'error' ? <i className={'ri-error-warning-line'} /> : <i className={'ri-checkbox-circle-line'} />}
        <span data-testid={'submission-title'}>{title}</span>
      </Col>
      <Col span={24} className={cx(Spacing.my12, type === 'success' ? TextAlign.center : TextAlign.left)}>
        {type === 'error' ? (
          <MFormItemError value={message} testId={'submission-error'} />
        ) : (
          <span className={messageSpanStyle} data-testid={'submission-text-message'}>
            {message}
          </span>
        )}
      </Col>
    </Row>
  );
};
